/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { paramCase } from 'change-case';
import * as getStatic from '@backpackjs/core-nextjs/get-static';
import { useCustomerAuth, useSettings } from '@backpackjs/storefront';

import templates from '../../templates/account';
import { AccountsAuthLoader } from '../../_components';

const isBrowser = typeof window !== 'undefined';

export const getStaticProps = getStatic.props.settings;
export const getStaticPaths = getStatic.paths.account;

export default function Account({ settings: initialSettings }) {
  const liveSettings = useSettings();
  const settings = liveSettings || initialSettings;
  const router = useRouter();
  const [AccountSubTemplate, setAccountSubTemplate] = useState(null);
  const [first, setFirst] = useState(true);

  // If account.menu has been set, we use the first item in the list as default subRoute
  const defaultAccountTemplateComp = 'orders';

  const { customer, authenticated } = useCustomerAuth({
    autoRedirect: true,
    defaultRoute: `/account/orders`,
    id: 'withAccount',
  });

  /*
      Map an template/account/*.jsx component to an /account/subRoute
      Doing this in a useEffect is important so that these chunked out templates get dynamically loaded
    */
  useEffect(() => {
    if (authenticated === undefined) return;
    let TemplateComponent = null;
    let TemplateComponentName;

    if (typeof templates !== 'object' || !Object.keys(templates).length) {
      return;
    }

    const subRoute = router?.query?.route?.[0];

    if (subRoute) {
      TemplateComponentName = paramCase(subRoute);
      const haveTemplateForSubRoute = templates[TemplateComponentName];

      if (haveTemplateForSubRoute) {
        // If we have an account template matching this subRoute we use the template;
        TemplateComponent = templates[TemplateComponentName];
      } else {
        // The subRoute is not defined in the menu and there's no template for it. Display the default account template
        TemplateComponent = templates[defaultAccountTemplateComp];
      }
    } else if (templates[defaultAccountTemplateComp]) {
      // path is /accounts e.g no subRoute
      // We render the first menu item as default
      TemplateComponent = templates[defaultAccountTemplateComp];
    }

    const activeAccountTemplate = TemplateComponent ? (
      <React.Suspense fallback="Loading...">
        <TemplateComponent settings={settings} customer={customer} />
      </React.Suspense>
    ) : (
      <p>`${TemplateComponentName} account template not defined`</p>
    );

    setAccountSubTemplate(activeAccountTemplate);
  }, [router?.query?.route?.[0], authenticated, templates, customer]);

  useEffect(() => {
    setFirst(false);
  }, []);

  if (!isBrowser) return null;

  if (first) {
    return null;
  }

  // render the correct account template based on the account/path
  return typeof window !== 'undefined' && customer && AccountSubTemplate ? (
    AccountSubTemplate
  ) : (
    <AccountsAuthLoader />
  );
}
